import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import FollowUpPanel from "@/components/FollowUpPanel";
import FinalCta from "@/components/FinalCta";
import { useSite } from "@/context/SiteContext";

export default function AboutPage() {
  const { config, content } = useSite();
  const about = content.about || {};
  const sections = [
    ["Who we are", about.intro],
    ["Lawrence Williams's role", about.role],
    ["The Coastal Energy relationship", about.relationship],
    ["Who designs, contracts, installs and services", about.responsibilities],
    ["Service territories", about.territories],
    ["Credentials & licenses", about.credentials],
    ["Warranties", about.warranties],
  ];
  return (
    <>
      <Seo
        title="About | Coastal Energy — Commercial Solar ROI"
        description="Commercial Solar ROI is Coastal Energy's dedicated commercial solar platform, providing project assessments, financial calculators, utility-bill reviews, and solar-plus-storage planning. Lawrence Williams leads commercial sales. Call 310-881-5155."
      />
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">ABOUT</span>
          <h1 data-testid="about-heading">Coastal Energy's commercial solar division.</h1>
          <p className="lead">
            One company, one door: commercialsolarroi.com is Coastal Energy's dedicated commercial solar platform, and
            commercial and residential solar leads complete their whole journey here — call or text 310-881-5155.
          </p>
        </div>
      </section>
      <section style={{ paddingBottom: 30 }}>
        <div className="wrap prose" data-testid="about-content">
          {sections.map(([title, body]) =>
            body ? (
              <Reveal key={title}>
                <h2>{title}</h2>
                <p>{body}</p>
              </Reveal>
            ) : null,
          )}
          <h2>How we talk about our brand</h2>
          <p>
            The Solar Black Belt name and the Roi Solar mascot are this platform's own brand voice; the line “{config.brandLine}” says
            exactly who stands behind it: Coastal Energy. Commercial Solar ROI is Coastal Energy's dedicated commercial solar
            platform — where a credential, territory or warranty detail is not part of the verified company records, it is omitted
            instead of implied.
          </p>
        </div>
      </section>
      <section style={{ paddingBottom: 60 }}>
        <div className="wrap split2">
          <Reveal>
            <div className="infopanel">
              <span className="eyebrow">REACH THE TEAM</span>
              <h2 style={{ margin: "12px 0" }}>{config.phone}</h2>
              <p style={{ color: "#c1d6cf", fontSize: 14 }}>
                Ask about projects, availability in your area, or an existing system. Prefer writing? Use the contact page.
              </p>
              <p style={{ marginTop: 18 }}><a href={config.phoneHref}>Call {config.phone} ↗</a> &nbsp; <a href="/contact">Send a message ↗</a></p>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <FollowUpPanel />
          </Reveal>
        </div>
      </section>
      <FinalCta title={["Let's talk about", "your building."]} service="commercial" context="Quote request" />
    </>
  );
}
